import { BaseConfig } from '../ServiceConfig';

export interface TempiConfiguration extends BaseConfig {
  '@type': 'type.googleapis.com/terra.v1.TempiServiceConfigData';
  url: string;
  domain: string;
}

export const TempiConfigurationFields: (keyof TempiConfiguration)[] = [
  'url',
  'domain',
];

export const BlankTempiConfiguration: TempiConfiguration = {
  '@type': 'type.googleapis.com/terra.v1.TempiServiceConfigData',
} as TempiConfiguration;
